/*
Locks

  --mount <string::enum> | ['Horizontal', 'Vertical']
  --setBack <float> | inches
  --throwDistance <float> | inches
  --materialThickness <float> | inches | default: 3/4"

*/

import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  {
    label: 'Mount',
    value: 'mount',
    type: 'list',
    returnObject: false
  },
  {
    label: 'Set Back',
    value: 'setBack',
    type: 'range'
  },
  {
    label: 'Throw Distance',
    value: 'throwDistance',
    type: 'range'
  },
  {
    label: 'Material Thickness',
    value: 'materialThickness',
    type: 'range'
  }
]
